import { useEffect, useState } from "react";
import { AudienceMapState, subscribeAudienceMap } from "../services/audience/audienceMap";

export default function useAudienceMap(mapId: string | null, signedIn: boolean): AudienceMapState {
  const [state, setState] = useState<AudienceMapState & { mapId: string | null }>({
    mapId: null, status: "loading", map: null, features: {},
  });
  useEffect(() => {
    if (!signedIn || !mapId) {
      setState({ mapId: null, status: "loading", map: null, features: {} });
      return;
    }
    return subscribeAudienceMap(mapId, next => setState({ ...next, mapId }));
  }, [mapId, signedIn]);
  // Never expose the previous map for even one render after changing selection.
  if (!mapId) return { status: "unavailable", map: null, features: {} };
  if (!signedIn || state.mapId !== mapId) return { status: "loading", map: null, features: {} };
  return state;
}
